import React, { useState, useEffect } from 'react';
import './EmailVerificationForm.css';

function EmailVerificationForm({ 
  email, 
  onEmailChange, 
  onSubmit, 
  isLoading, 
  error,
  attempts = 0 
}) {
  const [emailError, setEmailError] = useState('');
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [honeypot, setHoneypot] = useState('');

  useEffect(() => {
    // Show CAPTCHA after 2 failed attempts
    if (attempts >= 2) {
      setShowCaptcha(true);
    }
  }, [attempts]);

  const validateEmail = (value) => {
    if (!value) {
      setEmailError('Email is required');
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setEmailError('Please enter a valid email address');
      return false;
    }

    if (!value.toLowerCase().endsWith('@cafuamanagement.com')) {
      setEmailError('Please use your @cafuamanagement.com email address');
      return false;
    }

    setEmailError('');
    return true;
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    onEmailChange(value);
    if (value) {
      validateEmail(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Check honeypot
    if (honeypot) {
      console.log('Bot detected');
      return;
    }

    if (validateEmail(email)) {
      onSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="email-verification-form">
      <div className="form-group">
        <label htmlFor="email">Email Address</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={handleEmailChange}
          placeholder="your.name@cafuamanagement.com"
          required
          autoComplete="email"
          disabled={isLoading}
          className={emailError ? 'error' : ''}
        />
        {emailError && (
          <div className="field-error">{emailError}</div>
        )}
      </div>

      {/* Honeypot field - hidden from users */}
      <input
        type="text"
        name="website"
        value={honeypot}
        onChange={(e) => setHoneypot(e.target.value)}
        style={{ display: 'none' }}
        tabIndex="-1"
        autoComplete="off"
      />

      {showCaptcha && (
        <div className="captcha-notice">
          <p>⚠️ Multiple attempts detected. Please verify you're human.</p>
          {/* Add actual CAPTCHA implementation here */}
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={isLoading || !email || emailError}
        className="submit-button"
      >
        {isLoading ? 'Sending...' : 'Send Reset Link'}
      </button>

      <div className="form-note">
        <p>
          You will receive an email with instructions on how to reset your password.
        </p>
      </div>
    </form>
  );
}

export default EmailVerificationForm;